import { EXTERNAL_NAME } from './external-name';

export function getRuntimeReference() {
    return window[EXTERNAL_NAME].AppletHost;
}